import { getLocale } from '@umijs/max';

import enMenu from '@/locales/en-US/menu';
import jaMenu from '@/locales/ja-JP/menu';
import zhCnMenu from '@/locales/zh-CN/menu';
import zhTwMenu from '@/locales/zh-TW/menu';

export type RuntimeMenuItem = {
  key?: string;
  name?: string;
  path?: string;
  locale?: string;
  title?: string;
  icon?: React.ReactNode | string;
  children?: RuntimeMenuItem[];
  hideInMenu?: boolean;
  redirect?: string;
  [key: string]: any;
};

const menuLocales: Record<string, Record<string, string>> = {
  'zh-CN': zhCnMenu,
  'en-US': enMenu,
  'ja-JP': jaMenu,
  'zh-TW': zhTwMenu,
};

const legacyLocaleMap: Record<string, string> = {
  'menu.zy-crm.collaboration': 'menu.zy-crm.collaboration',
  'menu.zy-crm.collaboration.calendar': 'menu.zy-crm.collaboration.calendar',
  'menu.zy-crm.collaboration.follow-ups': 'menu.zy-crm.collaboration.followUps',
  'menu.zy-crm.collaboration.followUps': 'menu.zy-crm.collaboration.followUps',
  'menu.zy-crm.collaboration.tasks': 'menu.zy-crm.collaboration.tasks',
  'menu.zy-crm.collaboration.attachments':
    'menu.zy-crm.collaboration.attachments',
  'menu.zy-crm.leads': 'menu.zy-crm.leadManagement',
  'menu.zy-crm.leads.my': 'menu.zy-crm.leadManagement.lead.my',
  'menu.zy-crm.leads.team': 'menu.zy-crm.leadManagement.lead.team',
  'menu.zy-crm.leads.collab': 'menu.zy-crm.leadManagement.lead.collab',
  'menu.zy-crm.leads.pool': 'menu.zy-crm.leadManagement.lead.pool',
  'menu.zy-crm.leads.all': 'menu.zy-crm.leadManagement.lead.all',
  'menu.zy-crm.customers': 'menu.zy-crm.customerManagement',
  'menu.zy-crm.customers.my': 'menu.zy-crm.customerManagement.customer.my',
  'menu.zy-crm.customers.team': 'menu.zy-crm.customerManagement.customer.team',
  'menu.zy-crm.customers.collab':
    'menu.zy-crm.customerManagement.customer.collab',
  'menu.zy-crm.customers.pool': 'menu.zy-crm.customerManagement.customer.pool',
  'menu.zy-crm.customers.all': 'menu.zy-crm.customerManagement.customer.all',
  'menu.zy-crm.contacts': 'menu.zy-crm.customerManagement.contact',
  'menu.zy-crm.contacts.my': 'menu.zy-crm.customerManagement.contact.my',
  'menu.zy-crm.contacts.team': 'menu.zy-crm.customerManagement.contact.team',
  'menu.zy-crm.contacts.collab':
    'menu.zy-crm.customerManagement.contact.collab',
  'menu.zy-crm.contacts.all': 'menu.zy-crm.customerManagement.contact.all',
  'menu.zy-crm.opportunities': 'menu.zy-crm.salesManagement',
  'menu.zy-crm.opportunities.my': 'menu.zy-crm.salesManagement.opportunity.my',
  'menu.zy-crm.opportunities.followed':
    'menu.zy-crm.salesManagement.opportunity.followed',
  'menu.zy-crm.opportunities.team':
    'menu.zy-crm.salesManagement.opportunity.team',
  'menu.zy-crm.opportunities.collab':
    'menu.zy-crm.salesManagement.opportunity.collab',
  'menu.zy-crm.opportunities.all':
    'menu.zy-crm.salesManagement.opportunity.all',
  'menu.zy-crm.opportunities.pool':
    'menu.zy-crm.salesManagement.opportunity.pool',
  'menu.zy-crm.quotes': 'menu.zy-crm.salesManagement.quote',
  'menu.zy-crm.quotes.my': 'menu.zy-crm.salesManagement.quote.my',
  'menu.zy-crm.quotes.team': 'menu.zy-crm.salesManagement.quote.team',
  'menu.zy-crm.quotes.collab': 'menu.zy-crm.salesManagement.quote.collab',
  'menu.zy-crm.quotes.all': 'menu.zy-crm.salesManagement.quote.all',
  'menu.zy-crm.quotes.detail': 'menu.zy-crm.salesManagement.quote.detail',
  'menu.zy-crm.contracts': 'menu.zy-crm.contractAndReceipt',
  'menu.zy-crm.contracts.my': 'menu.zy-crm.contracts.my',
  'menu.zy-crm.contracts.team': 'menu.zy-crm.contracts.team',
  'menu.zy-crm.contracts.collab': 'menu.zy-crm.contracts.collab',
  'menu.zy-crm.contracts.all': 'menu.zy-crm.contracts.all',
  'menu.zy-crm.contracts.detail':
    'menu.zy-crm.contractAndReceipt.contract.detail',
  'menu.zy-crm.receipts': 'menu.zy-crm.contractAndReceipt.receipt',
  'menu.zy-crm.receipts.schedules':
    'menu.zy-crm.contractAndReceipt.receipt-schedule',
  'menu.zy-crm.receipts.schedules.detail':
    'menu.zy-crm.contractAndReceipt.receipt-schedule.detail',
  'menu.zy-crm.invoices': 'menu.zy-crm.contractAndReceipt.invoice',
  'menu.zy-crm.invoices.detail':
    'menu.zy-crm.contractAndReceipt.invoice.detail',
  'menu.zy-crm.customer': 'menu.zy-crm.customerManagement',
  'menu.zy-crm.customer.my': 'menu.zy-crm.customerManagement.customer.my',
  'menu.zy-crm.customer.pool': 'menu.zy-crm.customerManagement.customer.pool',
  'menu.zy-crm.customer.all': 'menu.zy-crm.customerManagement.customer.all',
  'menu.zy-crm.analytics.leadSource':
    'menu.zy-crm.analytics.leadSourceAnalysis',
  'menu.zy-crm.settings': 'menu.zy-crm.systemConfig',
  'menu.zy-crm.settings.general': 'menu.zy-crm.systemConfig.general',
  'menu.zy-crm.settings.lead': 'menu.zy-crm.systemConfig.lead',
  'menu.zy-crm.settings.customer': 'menu.zy-crm.systemConfig.customer',
  'menu.zy-crm.settings.opportunity': 'menu.zy-crm.systemConfig.opportunity',
  'menu.zy-crm.settings.contract': 'menu.zy-crm.systemConfig.contract',
  'menu.zy-crm.settings.automationRules':
    'menu.zy-crm.systemConfig.automationRules',
  'menu.zy-crm.settings.invoiceProfile':
    'menu.zy-crm.systemConfig.invoiceProfile',
  'menu.zy-crm.settings.customerPoolConfigs':
    'menu.zy-crm.systemConfig.customerPoolConfigs',
  'menu.zy-crm.settings.leadPoolConfigs':
    'menu.zy-crm.systemConfig.leadPoolConfigs',
  'menu.zy-crm.settings.leadAssignRules':
    'menu.zy-crm.systemConfig.leadAssignRules',
  'menu.zy-crm.settings.customerLimitConfigs':
    'menu.zy-crm.systemConfig.customerLimitConfigs',
  'menu.zy-crm.settings.dictionaryManagement':
    'menu.zy-crm.systemConfig.dictionaryManagement',
  'menu.zy-crm.settings.opportunityPipelines':
    'menu.zy-crm.systemConfig.opportunityPipelines',
  'menu.zy-crm.settings.opportunityStages':
    'menu.zy-crm.systemConfig.opportunityStages',
  'menu.zy-crm.settings.areas': 'menu.zy-crm.systemConfig.areas',
  'menu.zy-crm.settings.sourceChannels':
    'menu.zy-crm.systemConfig.sourceChannels',
  'menu.zy-crm.settings.customerLevels':
    'menu.zy-crm.systemConfig.customerLevels',
  'menu.zy-crm.settings.industries': 'menu.zy-crm.systemConfig.industries',
  'menu.zy-crm.settings.contractConfigs':
    'menu.zy-crm.systemConfig.contractConfigs',
  'menu.zy-crm.settings.contractCodeRules':
    'menu.zy-crm.systemConfig.contractCodeRules',
};

const getMenuMessages = (locale?: string) => {
  return menuLocales[locale || getLocale()] || zhCnMenu;
};

const resolveMenuLocale = (rawKey?: string) => {
  if (!rawKey) {
    return '';
  }

  const normalizedKey = rawKey.startsWith('menu.')
    ? rawKey
    : rawKey.startsWith('zy-crm.')
      ? `menu.${rawKey}`
      : rawKey;

  return legacyLocaleMap[normalizedKey] || normalizedKey;
};

const resolveMenuSourceKey = (item: RuntimeMenuItem) => {
  return item.locale || item.name || item.key || '';
};

const resolveDisplayKey = (item: RuntimeMenuItem) => {
  return item.name || item.key || item.locale || '';
};

const resolveMenuTitle = (
  item: RuntimeMenuItem,
  messages: Record<string, string>,
) => {
  const localeKey = resolveMenuLocale(resolveMenuSourceKey(item));
  return (
    (localeKey && messages[localeKey]) ||
    (item.title as string | undefined) ||
    resolveDisplayKey(item) ||
    localeKey ||
    ''
  );
};

export const buildCrmMenuData = (
  menuData: RuntimeMenuItem[] = [],
  locale?: string,
): RuntimeMenuItem[] => {
  const messages = getMenuMessages(locale);

  return menuData
    .filter((item) => !item.hideInMenu && !item.redirect)
    .map((item) => {
      const children = item.children
        ? buildCrmMenuData(item.children, locale)
        : undefined;
      return {
        ...item,
        title: resolveMenuTitle(item, messages),
        name: resolveMenuTitle(item, messages),
        locale: resolveMenuLocale(resolveMenuSourceKey(item)),
        key: item.key || item.name,
        children,
        routes: children,
      };
    });
};
